let currentUtterance = null;

export const setCurrentUtterance = (utterance) => {
  if (currentUtterance) {
    window.speechSynthesis.cancel();
  }
  currentUtterance = utterance;
};

export const getCurrentUtterance = () => currentUtterance;
